import { useTranslation } from "react-i18next"

import { WarningIcon } from "@/components/icons"

import { OverlayBackgroundImage, OverlayBase } from "./components"

export const WarningOverlay = (props: { base: string; terms: string }) => {
  const { t } = useTranslation()
  return (
    <OverlayBase
      className="bg-warning-primary text-warning-primary"
      Icon={<WarningIcon />}
      {...props}
    >
      <OverlayBackgroundImage className="bg-[url(@/components/icons/svg/warningIcon.svg)]">
        <p className="text-md-bold text-primary" role="alert">
          {t("liveRates.executionResponse.warning.takingLonger")}
        </p>
      </OverlayBackgroundImage>
    </OverlayBase>
  )
}
